import { Outlet } from "react-router-dom";
import TasksKanban from "./TasksKanban";

export const adminTasksRoutes = [
  {
    path: "tasks",
    element: Outlet,
    children: [
      {
        path: "",
        element: TasksKanban,
      },
    ],
  },
];
